import React from 'react';
import BasePage from '../../baseClasses/BasePage';
import NotificationsSettings from './NotificationsSettings';
import ApplicationInformation from './ApplicationInformation';
import ExpandableSection from '../../components/ExpandableSectionSettings';
import LanguageOptions from '../../components/LanguageOptions';
import dataModel from '../../models/DataModel';
//import OfflineToggle from './OfflineToggle';

import './UserSettings.scss';

class UserSettings extends BasePage {
  render() {
    const { isMobile } = this.props;

    return (
      <div className={'UserSettings' + (!isMobile ? ' UserSettings--web' : '')}>
        {
          !isMobile &&
          <div className='user-settings-header'>
            <h1 className='user-settings-header__text'>
              Settings
            </h1>
          </div>
        }

        {/* { isMobile && (<ExpandableSection
          name="OFFLINE MODE"
          initiallyExpanded={true}
          hasBreakLine={true}
        >
          <OfflineToggle 
            headerText="Work Offline"
            descriptionText="Enables you to work in Offline Mode regardless of your network connection status."
          />
        </ExpandableSection>)} */}

        <ExpandableSection 
          name={this.textMap.notifications} 
          initiallyExpanded={true}
          hasBreakLine={true}
        >
          <NotificationsSettings 
            key="email-notifications"
            userToUpdate={this.props.currentUser} 
            notificationType="settings_email_notifications"
            settingsKey="email_notifications"
            headerText={this.textMap.receiveEmailNotifications}
            descriptionText={this.textMap.receiveEmailNotificationsDescription}
          />
        {
          isMobile &&           
          <NotificationsSettings 
          key="push-notifications"
          userToUpdate={this.props.currentUser} 
            notificationType="push_notifications" 
            settingsKey="push_notifications" 
            headerText={this.textMap.receivePushNotifications}
            descriptionText={this.textMap.receivePushNotificationsDescription}
          />
        }
        </ExpandableSection>
        
        {
          isMobile && dataModel.companiesDAO.currentCompany.features &&
            dataModel.companiesDAO.currentCompany.features.internationalization &&
            dataModel.companiesDAO.currentCompany.features.internationalization.enabled &&
          <ExpandableSection
            name={this.textMap.languageOptions}
            initiallyExpanded={false}
            hasBreakLine={true}
          >
            <LanguageOptions />
          </ExpandableSection>
        }

        <ExpandableSection
          name={this.textMap.applicationInformation}
          initiallyExpanded={true}
          hasBreakLine={true}
        >
          <ApplicationInformation 
            isMobile={this.props.isMobile}
          />
        </ExpandableSection>
        {
          !isMobile &&
          <button 
            className='user-settings-button'
            onClick={this.props.closeSettings}
          >
            {this.textMap.done.toUpperCase()}
          </button>
        }
      </div>

    );
  }
}

export default UserSettings;



// WEBPACK FOOTER //
// ./src/components/UserSettings/index.js